module.exports = __webpack_public_path__ + "img/274.1f52d764.png";